import { Button, Card, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import theme from '../../../styles/theme';
import { STATUS } from '../../../constants/subscriptions';
import { TimerIcon } from '../../../resources/icons';
import { useSelector } from 'react-redux';
import { getTranslationValueFromKey } from '../../../utils/helpers';
import { t } from 'i18next';

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !['variant', 'backgroundColor', 'textColor'].includes(prop),
})(({ variant, backgroundColor, textColor }) => ({
  ...(variant === 'contained' && {
    ...theme.typography.h5,
    fontSize: '12px',
    borderRadius: '10px',
    backgroundColor: backgroundColor,
    color: textColor,
    boxShadow: 'none',
    cursor: 'text',
    pointerEvents: 'none', // Optional: Prevents any click or hover effects
    '&:hover': {
      backgroundColor: backgroundColor,
      boxShadow: 'none',
      cursor: 'text',
    },
    '&.Mui-disabled': {
      backgroundColor: backgroundColor,
      color: textColor,
    },
  }),
}));

const StatusButton = (props) => {
  const { words: staticWords } = useSelector((state) => state.handlingTranslation);
  const { variant, status } = props;
  const [btnStatus, setBtnStatus] = useState({});
  useEffect(() => {
    if (status === 'external') {
      setBtnStatus({
        color: theme.palette.text.orange,
        label: t('External'),
        backgroundColor: theme.palette.background.light,
      });
    } else if (status === 'active' || status === 'paid') {
      setBtnStatus({
        color: theme.palette.text.success,
        label: staticWords[getTranslationValueFromKey(STATUS[status])],
        backgroundColor: theme.palette.success.light,
      });
    } else if (status === 'unpaid' || status === 'incomplete') {
      setBtnStatus({
        color: theme.palette.error.lighter,
        label: staticWords[getTranslationValueFromKey(STATUS[status])],
        backgroundColor: theme.palette.background.error,
      });
    } else if (
      status === 'past_due' ||
      status === 'incomplete_expired' ||
      status === 'paused' ||
      status === 'canceled'
    ) {
      setBtnStatus({
        color: theme.palette.error.lighter,
        label: staticWords[getTranslationValueFromKey(STATUS['past_due'])],
        backgroundColor: theme.palette.background.error,
      });
    } else if (status === 'trialing') {
      setBtnStatus({
        color: theme.palette.text.orange,
        label: staticWords[getTranslationValueFromKey(STATUS[status])],
        backgroundColor: theme.palette.background.light,
      });
    } else if (status === 'open' || status === 'void' || status === 'uncollectible') {
      setBtnStatus({
        color: theme.palette.text.lightDark,
        label: staticWords[getTranslationValueFromKey(STATUS[status])],

        backgroundColor: theme.palette.background.lightDark,
      });
    } else if (status === 'overdue') {
      setBtnStatus({
        color: theme.palette.error.lighter,
        label: staticWords[getTranslationValueFromKey(STATUS[status])],
        backgroundColor: theme.palette.background.error,
      });
    }
    // else if (status === 'incomplete_expired' || status === 'incomplete' || status === 'paused') {
    //   setBtnStatus({
    //     color: theme.palette.text.lightDark,
    //     label: staticWords[getTranslationValueFromKey(STATUS[status])],
    //     backgroundColor: theme.palette.background.lightDark,
    //   });
    // }
    else {
      setBtnStatus({
        color: theme.palette.text.lightDark,
        label: props.status,
        startIcon: <TimerIcon />,
        backgroundColor: theme.palette.background.lightDark,
      });
    }
  }, [props, staticWords]);

  return (
    <StyledButton
      variant={'contained'}
      backgroundColor={btnStatus.backgroundColor}
      textColor={btnStatus.color}
      startIcon={btnStatus?.startIcon}
      sx={props.btnStyles}
      disabled={true}
    >
      {btnStatus.label}
    </StyledButton>
  );
};

export default StatusButton;
